(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  const overlay      = document.getElementById('sd-overlay');
  const drawer       = document.getElementById('sd-drawer');
  const closeBtn     = document.getElementById('sd-close');
  const input        = document.getElementById('sd-input');
  const defaultState = document.getElementById('sd-default-state');
  const resultsLive  = document.getElementById('sd-results-live');
  const spinner      = document.getElementById('sd-spinner');
  const noResults    = document.getElementById('sd-no-results');
  const viewAll      = document.getElementById('sd-view-all');
  const viewAllLink  = document.getElementById('sd-view-all-link');

  if (!overlay || !drawer || !input) return;

  let activeAbort = null;

  /* ================================
     Utilities
  ================================= */

  function debounce(fn, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  function escapeHTML(str) {
    return String(str).replace(/[&<>"']/g, function (m) {
      return ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      })[m];
    });
  }

  function formatMoney(price) {
  const priceInSubunits = Math.round(parseFloat(price) * 100);
  if (window.Shopify && Shopify.formatMoney) {
    return Shopify.formatMoney(priceInSubunits);
  }
  const moneyFormat = document.getElementById('sd-config')?.dataset?.moneyFormat || '₹{{amount}}';
  return moneyFormat.replace('{{amount}}', parseFloat(price).toLocaleString('en-IN', { maximumFractionDigits: 0 }));
}

  function highlightMatch(text, term) {
    if (!term) return escapeHTML(text);
    const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escaped})`, 'gi');
    return escapeHTML(text).replace(regex, '<mark>$1</mark>');
  }

  /* ================================
     Drawer Controls
  ================================= */

  function openDrawer() {
    overlay.classList.add('sd-open');
    drawer.classList.add('sd-open');
    document.body.classList.add('sd-locked');
    input.focus();
  }

  function closeDrawer() {
    overlay.classList.remove('sd-open');
    drawer.classList.remove('sd-open');
    document.body.classList.remove('sd-locked');
    reset();
  }

  function reset() {
    input.value = '';
    resultsLive.innerHTML = '';
    defaultState.hidden = false;
    spinner.hidden = true;
    noResults.hidden = true;
    viewAll.hidden = true;
  }

  function showLoading() {
    defaultState.hidden = true;
    spinner.hidden = false;
    resultsLive.hidden = true;
    noResults.hidden = true;
    viewAll.hidden = true;
  }

  function showResults() {
    spinner.hidden = true;
    resultsLive.hidden = false;
    viewAll.hidden = false;
  }

  function showEmpty() {
    spinner.hidden = true;
    resultsLive.hidden = true;
    noResults.hidden = false;
    viewAll.hidden = true;
  }

  /* ================================
     Predictive Search API
  ================================= */

  const doSearch = debounce(function (query) {

    const term = query.trim();
    if (!term.length) {
      reset();
      return;
    }

    if (activeAbort) activeAbort.abort();
    activeAbort = new AbortController();

    showLoading();

    const url = new URL('/search/suggest.json', location.origin);
    url.searchParams.set('q', term);
    url.searchParams.set('resources[type]', 'product,collection,page');
    url.searchParams.set('resources[limit]', '6');

    fetch(url.toString(), { signal: activeAbort.signal })
      .then(res => {
        if (!res.ok) throw new Error('Search failed');
        return res.json();
      })
      .then(data => {

        const results = data?.resources?.results || {};
        const products = results.products || [];
        const collections = results.collections || [];
        const pages = results.pages || [];

        if (!products.length && !collections.length && !pages.length) {
          showEmpty();
          return;
        }

        let html = '';

        /* ===== PRODUCTS ===== */
        if (products.length) {
          html += `<h4 class="sd-section__title">Products</h4>`;
          html += `<ul class="sd-products">`;

          products.forEach(product => {
            const image = product.featured_image
              ? product.featured_image.url + '&width=150'
              : '';

            html += `
              <li class="sd-product">
                <a class="sd-product__link" href="${product.url}">
                  <div class="sd-product__image-wrap">
                    ${image
                      ? `<img src="${image}"
                              class="sd-product__image"
                              alt="${escapeHTML(product.title)}" />`
                      : `<div class="sd-product__image sd-product__image--placeholder"></div>`
                    }
                  </div>
                  <div class="sd-product__info">
                    <p class="sd-product__title">
                      ${highlightMatch(product.title, term)}
                    </p>
                    <div class="sd-product__price-wrap">
                      <span class="sd-product__price">
                        ${formatMoney(product.price)}
                      </span>
                    </div>
                  </div>
                </a>
              </li>
            `;
          });

          html += `</ul>`;
        }

        /* ===== COLLECTIONS ===== */
        if (collections.length) {
          html += `<h4 class="sd-section__title">Collections</h4>`;
          html += `<ul class="sd-products">`;

          collections.forEach(collection => {
            html += `
              <li class="sd-product">
                <a class="sd-product__link" href="${collection.url}">
                  <div class="sd-product__info">
                    <p class="sd-product__title">
                      ${highlightMatch(collection.title, term)}
                    </p>
                    <p class="sd-product__type">Collection</p>
                  </div>
                </a>
              </li>
            `;
          });

          html += `</ul>`;
        }

        /* ===== PAGES ===== */
        if (pages.length) {
          html += `<h4 class="sd-section__title">Pages</h4>`;
          html += `<ul class="sd-products">`;

          pages.forEach(page => {
            html += `
              <li class="sd-product">
                <a class="sd-product__link" href="${page.url}">
                  <div class="sd-product__info">
                    <p class="sd-product__title">
                      ${highlightMatch(page.title, term)}
                    </p>
                    <p class="sd-product__type">Page</p>
                  </div>
                </a>
              </li>
            `;
          });

          html += `</ul>`;
        }

        resultsLive.innerHTML = html;

        const searchResultsUrl = new URL('/search', location.origin);
        searchResultsUrl.searchParams.set('q', term);
        searchResultsUrl.searchParams.set('type', 'product');
        viewAllLink.href = searchResultsUrl.toString();

        showResults();
      })
      .catch(err => {
        if (err.name === 'AbortError') return;
        showEmpty();
      });

  }, 300);

  /* ================================
     Events
  ================================= */

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-search-drawer]')) {
      e.preventDefault();
      openDrawer();
    }
  });

  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('sd-open')) {
      closeDrawer();
    }
  });

  input.addEventListener('input', function () {
    doSearch(this.value);
  });

  drawer.addEventListener('click', function (e) {
    const tag = e.target.closest('[data-sd-tag]');
    if (!tag) return;
    input.value = tag.textContent.trim();
    doSearch(input.value);
  });

})();
  } catch(e) { console.error(e); }
})();

})();
